import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../App";

// Hygiena on/off state (founder-controlled). Off until the server says otherwise.
export const useHygienaEnabled = (active) => {
  const [enabled, setEnabled] = useState(null);
  useEffect(() => {
    if (!active) return undefined;
    const load = () => axios.get(`${API}/hygiena-status`).then((r) => setEnabled(!!r.data.enabled)).catch(() => setEnabled(false));
    load();
    window.addEventListener("hygiena-switch", load);
    return () => window.removeEventListener("hygiena-switch", load);
  }, [active]);
  return enabled;
};
